import AttachmentIcon from "@material-ui/icons/Attachment";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React, { FunctionComponent } from "react";

const useFileCardStyle = makeThemedStyles("FileCardStyle", (theme) => ({
  FileCard: {
    color: "#4C5157",
    cursor: "pointer",
    display: "flex",
    padding: "0.5em",
    position: "relative",
    fontSize: "1.5em",
    minWidth: "200px",
    background: "rgb(250,250,250)",
    textAlign: "center",
    alignItems: "center",
    borderColor: "rgb(232,234,237)",
    borderStyle: "solid",
    borderWidth: "1px",
    marginRight: "0.3em",
    borderRadius: "8px",
    justifyContent: "space-between",
    "& img": {
      width: "25px",
      height: "25px",
      color: "#8FB8CC",
      fill: "#8FB8CC",
    },
    "& .icon": {
      borderInlineStart: "1px solid grey",
      paddingInlineStart: "5px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      color: "#8FB8CC",
    },
  },
}));

export interface FileCardProps {
  fileName: string;
  onClick?: () => void;
}

export const FileCard: FunctionComponent<FileCardProps> = (props) => {
  const style = useFileCardStyle();
  return (
    <div className={style.FileCard} onClick={props.onClick}>
      <AttachmentIcon className="icon" />

      <div>{props.fileName}</div>
      <div className="icon">
        <VisibilityIcon />
      </div>
    </div>
  );
};
//   <FileCard onClick={()=>{}} fileName="report.pdf"/>
